export const policyNotReceivedEndpoints = (builder) => ({
    getPolicyNotReceivedList: builder.query({
        query: (args = {}) => {
            const {
                pageNumber = 1,
                pageSize = 10,
                searchTerm,
                filterColumn,
                filterValue
            } = args;

            const params = {
                pageNumber,
                pageSize,
            };

            if (searchTerm) params.searchTerm = searchTerm;
            if (filterColumn) params.filterColumn = filterColumn;
            if (filterValue) params.filterValue = filterValue;

            return {
                url: '/GeneralInsurance/get-policy-not-received-list',
                method: 'POST',
                body: params,
            };
        },
        providesTags: ['PolicyNotReceived'],
    }),
});
